import { API } from "./api";

export const adminPlatformSettingsApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getAdminPlatformSettings: builder.query({
      query: () => ({
        url: "/admins/settings",
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "AdminPlatformSettings", id: "ROOT" }],
    }),

    updateMessagingProviders: builder.mutation({
      query: (body) => ({
        url: "/admins/settings/messaging-providers",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "AdminPlatformSettings", id: "ROOT" }],
    }),

    updateAdminPlatformSettings: builder.mutation({
      query: (body) => ({
        url: "/admins/settings/update",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "AdminPlatformSettings", id: "ROOT" }],
    }),
  }),
});

export const {
  useGetAdminPlatformSettingsQuery,
  useUpdateMessagingProvidersMutation,
  useUpdateAdminPlatformSettingsMutation,
} = adminPlatformSettingsApi;
